import { combineReducers } from 'redux';
import { without } from 'lodash/fp';
import { createReducer } from '@mews/framework';
import { createEntitiesReducer } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    CATEGORY_ADDED,
    CATEGORY_EDITED,
    CATEGORY_DELETED,
    CATEGORY_ORDERING_CHANGED,
    REDUCERS_RESET,
} from '../actions/types';

const categoriesReducer = createEntitiesReducer({
    ADD_SUCCESS: CATEGORY_ADDED,
    UPDATE_SUCCESS: CATEGORY_EDITED,
    DELETE_SUCCESS: CATEGORY_DELETED,
    RESET_SUCCESS: REDUCERS_RESET,
});

const INITIAL_STATE: string[] = [];

const orderingReducer = createReducer(INITIAL_STATE, {
    [CATEGORY_ADDED]: (state: string[], { id }: { id: string }) => [...state, id],
    [CATEGORY_DELETED]: (state: string[], { id }: { id: string }) => without([id], state),
    [CATEGORY_ORDERING_CHANGED]: (state: string[], ordering: string[]) => ordering,
    [REDUCERS_RESET]: () => INITIAL_STATE,
});

export default combineReducers({
    categoryOrdering: orderingReducer,
    categories: categoriesReducer,
});
